function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { EventCategory, EventType, useAnalyticsContent, eventExtensionText } from '../analytics';
import { config } from '../config';
export default function useAlertAnalytics(_ref) {
  var analytics = _ref.analytics,
    analyticsLabelOverride = _ref.analyticsLabelOverride,
    _ref$onAnalyticsEvent = _ref.onAnalyticsEvent,
    onAnalyticsEvent = _ref$onAnalyticsEvent === void 0 ? config().defaultAnalyticsFunction : _ref$onAnalyticsEvent,
    variation = _ref.variation;
  // Order matters! Content comes from the heading first and falls back to body if heading doesn't exist
  var _useAnalyticsContent = useAnalyticsContent({
      onMount: function onMount(content) {
        if (analytics !== true && (!config().alertSendsAnalytics || analytics === false)) {
          return;
        }

        // Do not send analytics event for default alerts
        if (!variation) {
          return;
        }
        var eventHeadingText = analyticsLabelOverride !== null && analyticsLabelOverride !== void 0 ? analyticsLabelOverride : content;
        if (!eventHeadingText) {
          console.error('No content found for Alert analytics event');
          return;
        }
        onAnalyticsEvent({
          event_name: 'alert_impression',
          event_type: EventType.UI_INTERACTION,
          event_action: 'alert impression',
          event_extension: eventExtensionText,
          event_category: EventCategory.UI_COMPONENTS,
          event_label: eventHeadingText,
          heading: eventHeadingText,
          type: variation
        });
      }
    }),
    _useAnalyticsContent2 = _slicedToArray(_useAnalyticsContent, 2),
    headingRef = _useAnalyticsContent2[0],
    bodyRef = _useAnalyticsContent2[1];
  return {
    headingRef: headingRef,
    bodyRef: bodyRef
  };
}